/**
 * 添加责任人
 */
import React, {useState, useEffect, useReducer, useRef} from 'react';
import {Form, Button, Select, Row, Col, message, Input, ConfigProvider, Checkbox, Spin} from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import {SFuncModal} from "shj-components";
import arrToListOption from "@/pages/homePage/components/addMatter";
import {getAllCompanyMrn, ticketsAddChargePerson, ticketsGetLoginUserAttr} from "@/services/customerServices.ts";

const {TextArea} = Input;

export const ModalAddchargePersonTab = (props: any) => <AddchargePersonDom {...props} />;

export const addchargePersonFn = (val: any) => {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: '添加责任人',
    vanish: true,
    content: (
        <>
          <ConfigProvider locale={zhCN}>
            <AddchargePersonDom onClose={onClose} {...val} />
          </ConfigProvider>
        </>
    ),
  });
  return dialog;
};

// 添加责任人
const AddchargePersonDom = (params: any) => {
  const {id, issueId, companyCode, onClose, fn, formOnly} = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);

  const [isCompanyCharge, setIsCompanyCharge] = useState(false);

  const [isDisposePerson, setIsDisposePerson] = useState<any>();
  const [isCopyPerson, setIsCopyPerson] = useState<any>();
  const [currentStatus, setCurrentStatus] = useState<any>();
  const [chargePerson, setChargePerson] = useState<any>({});

  const [state, dispatch] = useReducer(
      (state: any, action: any) => {
        return action;
      },
      {
        getStaffList: [],
      },
  );
  useEffect(() => {
    initFn();
  }, []);
  const initFn = async () => {
    setSpinLoading(true);
    try {
      return await new Promise((resolve, reject) => {
        Promise.all([getAllCompanyMrn({
          status: true,
          userIdentityFilter: {
            companyId: companyCode
          }
        }), ticketsGetLoginUserAttr(id)])
            .then((resp) => {
              setIsDisposePerson(resp[1]?.isDisposePerson);
              setIsCopyPerson(resp[1]?.isCopyPerson);
              setCurrentStatus(resp[1]?.status);

              const _getStaffList: any[] = resp[0];
              const listObj = {
                getStaffList: _getStaffList,
              };
              dispatch(listObj);
              setSpinLoading(false);
            })
            .catch((err) => {
              setSpinLoading(false);
            });
      });
    } catch (err_1) {
      setSpinLoading(false);
    }
  };

  const onFinish = () => {
    if (loading) return;
    if ((currentStatus == 1 || currentStatus == 2) && (isDisposePerson || isCopyPerson)) {
      form.validateFields().then(values => {
        setLoading(true);
        values['id'] = id;
        values['isCompanyCharge'] = isCompanyCharge;
        if (values.chargePerson) {
          values['chargePerson'] = chargePerson;
        }
        return ticketsAddChargePerson(values)
            .then(() => {
              message.success(`操作成功`);
              fn && fn();
              onClose();
            })
            .catch(() => {
              setLoading(false);
            });
      })
    } else {
      onClose()
    }
  };

  const {getStaffList} = state;
  return (
      <SFuncModal.Content
          confirmLoading={spinLoading || loading}
          onCancel={onClose}
          onOk={onFinish}
          {...{[formOnly ? 'footer' : '']: null}}
      >
        {(currentStatus == 1 || currentStatus == 2) && (isDisposePerson || isCopyPerson) ? (
            <>
              <div style={{padding: '20px', paddingTop: '0'}}>注意：此责任人仅可添加一次，不可修改， 请确认后填写！</div>
              <Form ref={formNode} form={form} onFinish={onFinish}>
                <Row>
                  <Col span={24}>
                    <Form.Item label=" " name="isCompanyCharge" colon={false}>
                      <Checkbox
                          onChange={(e) => {
                            setIsCompanyCharge(e.target.checked);
                          }}
                      >
                        非门店责任
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  {!isCompanyCharge ? (
                      <Col span={24}>
                        <Form.Item
                            label="责任说明"
                            name="chargeDesc"
                            required
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                          <TextArea placeholder="请输入内容" style={{width: '100%'}} maxLength={200} showCount/>
                        </Form.Item>
                      </Col>
                  ) : (
                      <Col span={24}>
                        <Form.Item
                            label="责任人"
                            name="chargePerson"
                            required
                            rules={[{required: true, message: '请选择'}]}
                        >
                          <Select
                              placeholder="请选择"
                              allowClear
                              showSearch
                              onChange={(_, op) => {
                                const {value, children} = op || {}
                                setChargePerson({ucenterUserId: value, userName: children})
                              }}
                              filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                          >
                            {arrToListOption(getStaffList, {value: 'ucenterUserId', title: 'userName'})}
                          </Select>
                        </Form.Item>
                      </Col>
                  )}
                </Row>
              </Form>
            </>
        ) : (
            <>{(spinLoading || loading) ? null : <div>当前状态或登录人不可操作</div>}</>
        )}
      </SFuncModal.Content>
  );
};
